import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

const Modals = () => {
  const modals = useSelector(state => state.modals.modals);
  const modalsMap = modals.map( m => 
    <m.component key={m.props.id} id={m.props.id} {...m.props} />
  );
  return (
    <Fragment>
      {modalsMap}
    </Fragment>
  );
};

export default Modals;